/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { Typography, useTheme } from "@mui/material";
import { CellProps } from "./MovementCell";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import { LayerModel } from "RosterData";
import LayerCell from "../Layers/LayerData";

interface OtherLocationCellProps extends CellProps {
  multiple: boolean;
  start: boolean;
  end: boolean;
  layer1: LayerModel[] | null;
}

const OtherLocationCell = (props: OtherLocationCellProps) => {
  const theme = useTheme();
  const calculateBorder = () => {
    if (props.multiple) {
      if (props.start) {
        return "5px 0 0 5px";
      } else if (props.end) {
        return "0 5px 5px 0px";
      } else {
        return 0;
      }
    } else {
      return 5;
    }
  };

  const determineCellType = () => {
    if (props.multiple) {
      if (props.start) {
        //This is the first cell of many ahead
        return (
          <>
            <div
              style={{
                display: "flex",
                color: "inherit",
              }}
            >
              <FmdBadIcon fontSize="small" />
              <Typography variant="caption" maxWidth={100} noWrap={true}>
                {props.location}
              </Typography>
            </div>
            <div>
              <Typography variant="caption" maxWidth={50} noWrap={true}>
                Other
              </Typography>
            </div>
            {props.layer1 && (
              <LayerCell data={props.layer1[0]} continue={false} />
            )}
          </>
        );
      } else {
        //This is continuation
        return (
          <>
            <span style={{ height: 44 }} />
            {props.layer1 && <LayerCell data={props.layer1[0]} continue />}
          </>
        );
      }
    } else {
      //Single Cell
      return (
        <>
          <div
            style={{
              display: "flex",
              color: "inherit",
            }}
          >
            <FmdBadIcon fontSize="small" />
            <Typography variant="caption" maxWidth={50} noWrap={true}>
              {props.location}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" maxWidth={50} noWrap={true}>
              Other
            </Typography>
          </div>
          {props.layer1 && (
            <LayerCell data={props.layer1[0]} continue={false} />
          )}
        </>
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        // padding: 5,
        background: theme.palette.cells.otherLocation.background,
        color: theme.palette.cells.otherLocation.text,
        borderRadius: calculateBorder(),
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        minHeight: 50,
      }}
    >
      {determineCellType()}
    </div>
  );
};

export default OtherLocationCell;
